require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-world-bank-works-to-address-gbv-related-ramifications.json") })
        }
      }, "path---en-us-update-world-bank-works-to-address-gbv-related-ramifications");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-world-bank-works-to-address-gbv-related-ramifications!./.cache/json/en-us-update-world-bank-works-to-address-gbv-related-ramifications.json
// module id = 877
// module chunks = 231608221292675